import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ClockIcon, LockIcon, UsersIcon, ZapIcon } from 'lucide-react';
import { CHECKOUT_URL, OLD_PRICE, PRICE } from '../lib/constants';
const TOTAL_CUPOS = 200;
const START_SECONDS = 23 * 60 + 45;
const resumen = [{
  label: 'Kit Profe de Fisicoquímica Resuelta — 16 fichas (PDF)',
  value: '$52.000'
}, {
  label: 'Bono 1 · Banco de 96 ejercicios resueltos',
  value: 'GRATIS'
}, {
  label: 'Bono 2 · Planificador anual editable',
  value: 'GRATIS'
}, {
  label: 'Bono 3 · Evaluaciones con rúbrica',
  value: 'GRATIS'
}, {
  label: 'Bono 4 · Laboratorios sin laboratorio',
  value: 'GRATIS'
}, {
  label: 'Bono 5 · Kit de gamificación',
  value: 'GRATIS'
}, {
  label: 'Bono 6 · Adaptaciones para alumnos',
  value: 'GRATIS'
}, {
  label: 'Bono 7 · Guía de simuladores PhET',
  value: 'GRATIS'
}, {
  label: 'Bono 8 · Atlas Visual de Fisicoquímica',
  value: 'GRATIS'
}];
const pad = (n: number) => String(n).padStart(2, '0');
export function OfertaFinal() {
  const [seconds, setSeconds] = useState(START_SECONDS);
  const [cupos, setCupos] = useState(37);
  useEffect(() => {
    const t = window.setInterval(() => {
      setSeconds(s => s <= 1 ? START_SECONDS : s - 1);
    }, 1000);
    return () => window.clearInterval(t);
  }, []);
  useEffect(() => {
    const t = window.setInterval(() => {
      setCupos(c => c > 8 ? c - 1 : c);
    }, 42000);
    return () => window.clearInterval(t);
  }, []);
  const pct = Math.round((TOTAL_CUPOS - cupos) / TOTAL_CUPOS * 100);
  return <section id="compra" className="scroll-mt-4 px-4 py-10" aria-labelledby="oferta-title" data-id="element-85" data-mp="29xcbg86osyb1">
      <div className="rounded-2xl border border-orange-400/30 bg-[#08262a]/90 p-4 shadow-2xl backdrop-blur" data-id="element-86" data-mp="24wy46scwtse2">
        <h2 id="oferta-title" className="text-center font-display text-xl font-extrabold text-white" data-id="element-87" data-mp="flxhff6n8cph">
          Llevate el kit completo hoy
        </h2>

        {/* Countdown */}
        <div className="mt-4 rounded-xl border border-red-400/30 bg-red-500/10 p-3" data-id="element-88" data-mp="2fmc4xk2nsf28">
          <p className="flex items-center justify-center gap-1.5 text-[11px] font-bold uppercase tracking-wider text-red-200" data-id="element-89" data-mp="2fo6sl65bela0">
            <ClockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-90" data-mp="2onjv1ev0u9l8" />
            La oferta termina en
          </p>
          <p className="mt-1 text-center font-display text-3xl font-extrabold tabular-nums text-white" aria-live="off" data-id="element-91" data-mp="2tl3jf7lfo2qw">
            00:{pad(Math.floor(seconds / 60))}:{pad(seconds % 60)}
          </p>

          <div className="mt-3 flex items-center justify-between text-[11px] font-semibold text-red-100" data-id="element-92" data-mp="33cq03jgjiu11">
            <span className="flex items-center gap-1" data-id="element-93" data-mp="38d3ye9scaplv">
              <UsersIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-94" data-mp="3cdny9l4as7bp" />
              Cupos restantes
            </span>
            <span data-id="element-95" data-mp="3hc8xpibq6mz3">
              {cupos} de {TOTAL_CUPOS}
            </span>
          </div>
          <div className="mt-1.5 h-2.5 w-full overflow-hidden rounded-full bg-white/10" role="progressbar" aria-valuenow={pct} aria-valuemin={0} aria-valuemax={100} aria-label="Cupos reservados" data-id="element-96" data-mp="15p5eo5fcpq6r">
            <motion.div className="h-full rounded-full bg-red-500" initial={false} animate={{
            width: `${pct}%`
          }} transition={{
            duration: 0.6
          }} data-id="element-97" data-mp="rpcvcv65mc8t" />
          </div>
          <p className="mt-1 text-center text-[10.5px] text-red-200/80" data-id="element-98" data-mp="1fm0fww30e4oq">
            {pct}% de los cupos ya fueron reservados
          </p>
        </div>

        {/* Resumen del pedido */}
        <div className="mt-5 rounded-xl border border-teal-300/20 bg-[#0b2b2e]/80 p-3.5" data-id="element-99" data-mp="282kwynk0pq23">
          <p className="mb-2 font-display text-[13px] font-bold uppercase tracking-wide text-teal-200" data-id="element-100" data-mp="23ce7klhom1is">
            Resumen de tu pedido
          </p>
          <ul className="divide-y divide-white/5" data-id="element-101" data-mp="1mv22fp8i6fmx">
            {resumen.map(r => <li key={r.label} className="flex gap-3 py-1.5" data-id="element-102" data-mp="1rwhnvieleo5u">
                <span className="flex-1 text-[12px] leading-snug text-teal-50/85" data-id="element-103" data-mp="1dw6vgaxmx1ik">
                  {r.label}
                </span>
                <span className={`flex-none text-[12px] font-bold ${r.value === 'GRATIS' ? 'text-emerald-400' : 'text-teal-100/60 line-through'}`} data-id="element-104" data-mp="1ivt7ih1q8bps">
                  {r.value}
                </span>
              </li>)}
          </ul>
          <div className="mt-2 flex items-center justify-between border-t border-white/10 pt-2" data-id="element-105" data-mp="1wvku366b70fe">
            <span className="text-[12px] font-semibold text-white" data-id="element-106" data-mp="21t2to5yfs3aq">
              Valor total real
            </span>
            <span className="text-[13px] font-bold text-teal-100/60 line-through" data-id="element-107" data-mp="2pioqimrc66fk">
              $134.000
            </span>
          </div>
        </div>

        {/* Precio */}
        <div className="mt-5 text-center" data-id="element-108" data-mp="33oh1g16gl0yy">
          <p className="text-sm font-semibold text-teal-100/70" data-id="element-109" data-mp="33n5wvz56vp6s">
            Antes{' '}
            <span className="line-through decoration-red-400 decoration-2" data-id="element-110" data-mp="2zmvoygxu6opa">
              {OLD_PRICE}
            </span>
          </p>
          <p className="font-display text-5xl font-extrabold leading-none text-white" data-id="element-111" data-mp="3dgmsn8ovzed3">
            {PRICE}
          </p>
          <p className="mt-1 text-[12px] font-semibold text-orange-300" data-id="element-112" data-mp="2kpl4wj74oahy">
            Pago único · Acceso de por vida
          </p>
        </div>

        <motion.a href={CHECKOUT_URL} animate={{
        scale: [1, 1.02, 1]
      }} transition={{
        duration: 2.2,
        repeat: Infinity,
        ease: 'easeInOut'
      }} className="mt-4 block w-full rounded-xl bg-[#e8590c] px-5 py-4 text-center font-display text-base font-extrabold uppercase tracking-wide text-white shadow-lg shadow-orange-900/40 ring-1 ring-orange-300/30 hover:bg-[#d24f08] focus:outline-none focus-visible:ring-4 focus-visible:ring-orange-300" data-id="element-113" data-mp="2gq3ztqvm5fdb">
          Resolvé tus clases hoy
          <span className="mt-1 block text-[11px] font-medium normal-case tracking-normal text-orange-100" data-id="element-114" data-mp="gzyjp8eva55v">
            Descarga inmediata después del pago
          </span>
        </motion.a>

        <div className="mt-3 flex flex-wrap justify-center gap-x-4 gap-y-1 text-[11px] text-teal-100/70" data-id="element-115" data-mp="qy4mds8hzfbs">
          <span className="flex items-center gap-1" data-id="element-116" data-mp="3piecg071akbh">
            <LockIcon className="h-3 w-3" aria-hidden="true" data-id="element-117" data-mp="3ufwklod88vif" />
            Pago seguro
          </span>
          <span className="flex items-center gap-1" data-id="element-118" data-mp="3a4w0tf3lqxq">
            <ZapIcon className="h-3 w-3" aria-hidden="true" data-id="element-119" data-mp="38k1h3ssa7zv" />
            Entrega inmediata
          </span>
          <span data-id="element-120" data-mp="82o9zrhp6o32">📄 100% PDF + Excel + Word</span>
        </div>
      </div>
    </section>;
}